export const ACTIVITY_LOG = {
  ACTIVITY_LOG_SET_SELECTED: "ACTIVITY_LOG_SET_SELECTED",
  ACTIVITY_LOG_CLEAR_SELECTED: "ACTIVITY_LOG_CLEAR_SELECTED",
};
